import styled from 'styled-components'

export const Card = styled.div`
    display:flex;
    margin: 10px 10px 10px 0;
    width: 100%;
    @media (min-width: 768px) { 
        
    }
    @media (min-width: 992px) { 
        
    }
    @media (min-width: 1200px) { 
        
    }
   

`
export const ContentLink = styled.div`
    display:flex;
    
`

export const Title = styled.div`
    font-size :16px;
    font-weight: 600;
    margin-left:10px;
    
    
`

export const Linkover = styled.a`
    display:flex;
    
    &:hover .titlelink{
        color:#D9A76A
    }
    
`

export const Desc = styled.div`
    font-size :16px;
    font-weight: 400;
    margin-left:10px;
    
    
`
export const Separador = styled.div`
    border-bottom:#EAEAEA solid 1px;
    margin: 14px 0;
    
    
`
export const Cont = styled.div`
    width:100%;
    
    
`









